export default __webpack_public_path__ + "static/media/logo-item-2.66881bb3.jpeg";